import React, { useState } from 'react';

function FAQPage() {
  const [expandedFAQ, setExpandedFAQ] = useState(null);

  const faqs = [
    {
      question: "Why is it called 'Billion Dollar Site'?",
      answer: "The name reflects our ambitious vision for the future. As blockchain technology and Ethereum continue to evolve, we believe this project represents the potential for massive value creation. Bitcoin grew from $1 to $69,000 (a 69,000x increase) in 12 years, and ETH rose from $0.30 to $4,800 (a 16,000x increase) in 8 years. With ETH currently at $2,500, each 1×1 block costs 0.25 ETH ($625). For the Billion Dollar Page to reach its namesake value, ETH would need to hit $400,000 - a 160x increase that would make each block worth $100,000. While this sounds ambitious, a 160x growth is actually modest compared to ETH's historical 16,000x journey. More than just a price prediction, it's about creating a permanent digital landmark that grows with the ecosystem."
    },
    {
      question: "What's the purpose of this project?",
      answer: "Billion Dollar Site is designed to create a **permanent digital monument** that showcases the power of blockchain ownership. Your pixels become **immutable pieces of internet history**. We're building a **global showcase** where individuals, artists, and brands can display their identity permanently on the blockchain. It's about **true digital ownership** - when you buy pixels, you own them forever as NFTs that can be traded on any marketplace."
    },
    {
      question: "What is Billion Dollar Site?",
      answer: "Unlike traditional platforms, your ownership is **verifiable and tradeable.** Each pixel block displays **your chosen image, links to your website, and includes your custom description** - creating a permanent digital gallery where art, brands, and messages live forever on the blockchain."
    },
    {
      question: "How much does it cost to buy pixels?",
      answer: "**1×1 Block:** 0.25 ETH (1 block) - Perfect for simple logos or icons\n\n**2×2 Block:** 1.0 ETH (4 blocks) - Good for small detailed images\n\n**5×5 Block:** 6.25 ETH (25 blocks) - Great for medium graphics\n\n**10×10 Block:** 25 ETH (100 blocks) - Best for large detailed artwork\n\n(Each individual pixel within a block costs **0.0025 ETH**)"
    },
     {
      question: "What should I do if I encounter errors or error messages",
      answer: "In case of any error messages or technical issues, it's always recommended to refresh the page and reconnect your wallet. This resolves most blockchain connection problems. If issues persist, ensure you're on Ethereum Mainnet and have sufficient ETH for gas fees."
    },
    {
      question: "What happens during the approval process?",
      answer: "All submissions go through a **manual review process** before minting. If your submission is approved, your image gets **permanently stored on Arweave** (decentralized storage) and your NFT is minted. If rejected for policy violations, you'll get your **ETH back** (minus network fees, which we cannot refund)."
    },
    {
      question: "What are the image requirements?",
      answer: "Your image must be accessible via a **direct URL ending in .png, .jpg**, or similar format. Please ensure your image is in a **square (1:1) format** - we don't provide image editing services. **Transparent images** will display with a plain white background. Make sure your image URL works before submitting, as we're **not responsible for broken or incorrect URLs**."
    },
    {
      question: "Can I change my image after purchase or get a refund?",
      answer: "**No, absolutely not.** To preserve the historical nature of this blockchain project: **minted is minted, final is final**. There are **no returns, exchanges, or changes** once your NFT is created. This ensures the grid maintains its integrity and historical value over time."
    },
    {
      question: "What about network fees?",
      answer: "Network fees (gas fees) are **necessary to make the blockchain work** and **cannot be refunded** under any circumstances. These fees go to Ethereum miners/validators, not to us. Even if your submission is rejected, you'll only get back the pixel purchase price - **network fees are always lost**."
    },
    {
      question: "How long does the process take?",
      answer: "The approval process can take time, especially as we also need to upload each approved image to Arweave for permanent storage. **Maximum processing time is 24-48 hours**, but it may be faster depending on the submission queue. Arweave uploads also take time to process. We're doing our best to handle everything manually with care. Thank you for your patience!"
    },
    {
      question: "Can I sell my pixels later?",
      answer: "Yes! All pixel blocks are minted as **ERC-721 NFTs**, which means they will **automatically appear on OpenSea** once minted. You can also sell or transfer them on **any NFT marketplace** that supports the Ethereum blockchain."
    },
    {
      question: "Do you receive royalties from resales?",
      answer: "Yes, the contract implements the **ERC-2981 royalty standard**, which means we receive **8% of any secondary sales** on marketplaces that support this standard."
    },
    {
      question: "Why do you need money?",
      answer: "Have you checked egg prices lately? Or seen the Nintendo Switch 2 prices? Look, running a blockchain project isn't free and a dev's gotta eat! 🥚💰"
    },
    {
      question: "Are you responsible for linked content?",
      answer: "**Absolutely not.** We **completely distance ourselves** from any content found on external websites linked from pixels. We are **not responsible**, **not liable**, and **do not endorse** any content, products, services, or information found on linked websites. Users must **verify and check all linked content themselves** at their own risk. We only provide the platform - the **full responsibility** for appropriate content and any consequences lies entirely with pixel owners."
    },
    {
      question: "Will there be a non-wallet version?",
      answer: "Once everything is sold out, we **might consider** creating a simple viewing version for **display purposes only** - essentially showing the completed pixel artwork as a finished image. This would be purely for **viewing the final result**, with **no guarantees** and no wallet functionality required."
    },
    {
      question: "Why keep the site design simple?",
      answer: "I was more interested in the Web3 blockchain 'never goes away' approach rather than fancy design. The focus is on permanence and true ownership, not flashy interfaces."
    },
    {
      question: "Where can I verify the official contract?",
      answer: "Always make sure you're interacting with the correct contract address displayed on our site. We're not responsible if you interact with scam contracts. Only use the official contract address shown in the app."
    }
  ];

  const toggleFAQ = (index) => {
    setExpandedFAQ(expandedFAQ === index ? null : index);
  };

  return (
    <div style={{
      maxWidth: '800px',
      minWidth: '800px',
      width: '800px',
      margin: '0 auto',
      padding: '20px',
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <h2 style={{ color: '#2E7D32', marginBottom: '30px' }}>Frequently Asked Questions</h2>
      
      {faqs.map((faq, index) => (
        <div key={index} style={{ 
          marginBottom: '15px',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          overflow: 'hidden',
          width: '100%',
          minWidth: '760px'
        }}>
          <div 
            onClick={() => toggleFAQ(index)}
            style={{ 
              padding: '15px',
              backgroundColor: expandedFAQ === index ? '#f5f5f5' : 'white',
              cursor: 'pointer',
              borderBottom: expandedFAQ === index ? '1px solid #e0e0e0' : 'none',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              transition: 'background-color 0.2s ease'
            }}
          >
            <h3 style={{ 
              color: '#333', 
              margin: 0,
              fontSize: '16px',
              flex: 1,
              paddingRight: '40px'
            }}>
              {faq.question}
            </h3>
            <div style={{
              fontSize: '18px',
              color: '#666',
              transform: expandedFAQ === index ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease',
              width: '30px',
              textAlign: 'center',
              flexShrink: 0
            }}>
              ▼
            </div>
          </div>
          
          {expandedFAQ === index && (
            <div style={{ 
              padding: '15px',
              backgroundColor: 'white',
              animation: 'fadeIn 0.3s ease'
            }}>
              <div style={{ 
                lineHeight: '1.6', 
                color: '#555',
                margin: 0,
                whiteSpace: 'pre-line'
              }}>
                {faq.answer.split('**').map((part, i) => 
                  i % 2 === 1 ? 
                    <strong key={i} style={{ color: '#2E7D32', fontWeight: '600' }}>{part}</strong> : 
                    part
                )}
              </div>
            </div>
          )}
        </div>
      ))}

      {/* Contact Section */}
      <div style={{
        marginTop: '40px',
        padding: '30px',
        backgroundColor: '#2E7D32',
        borderRadius: '16px',
        textAlign: 'center',
        maxWidth: '600px',
        margin: '40px auto 0',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: '-10px',
          left: '-10px',
          right: '-10px',
          bottom: '-10px',
          border: '3px solid #ff9800',
          borderRadius: '20px',
          zIndex: 0
        }}></div>
        
        <div style={{ position: 'relative', zIndex: 1 }}>
          <h3 style={{ 
            color: 'white', 
            margin: '0 0 15px',
            fontSize: '24px',
            fontWeight: 'bold'
          }}>
            Still have questions?
          </h3>
          <p style={{ 
            color: 'white', 
            margin: '0 0 20px',
            fontSize: '16px',
            opacity: 0.9
          }}>
            We're here to help! Reach out to us directly.
          </p>
          <a 
            href="mailto:billiondollarsite@protonmail.com"
            style={{
              display: 'inline-block',
              padding: '12px 24px',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 'bold',
              border: '2px solid rgba(255, 255, 255, 0.3)',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.3)';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            📧 Contact Us
          </a>
        </div>
      </div>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
}

export default FAQPage;